export default __webpack_public_path__ + "static/media/GettingStarted.5cc83c36.jpg";